export default __webpack_public_path__ + "static/newyorkoffice-72a2e46aa7adac4f1a56c647ab14fb53.png";